import { IDictionary } from '@interfaces';
import { createReducer, on } from '@ngrx/store';
import { loadDictionarySuccess } from './dictionary.actions';

export interface DictionaryState {
  dictionary: IDictionary[];
}

export const initialState: DictionaryState = {
  dictionary: [
    {
      variableName: '',
      english: '',
      hebrew: '',
      arabic: '',
      system: '',
    },
  ],
};

const _dictionaryReducer = createReducer(
  initialState,
  on(loadDictionarySuccess, (state, { dictionary }) => ({ ...state, dictionary })),
);

export function dictionaryReducer(state: DictionaryState | undefined, action: any) {
  return _dictionaryReducer(state, action);
}
